export default __webpack_public_path__ + "static/media/logo.ad96aba9.png";